import { combineReducers } from '@fullstory/redux-util/utils';
import { createRequestReducer } from '@fullstory/redux-util';
import { SsoActions } from './actions';
import { SsoRequestTypes } from './types';
import {
  ComputePreSsoConnectionInfoResponse,
  SsoSettings,
} from '@fullstory/proto/fs/services/orgs/orgs.proto';

const preSsoConnectionInfo = createRequestReducer<ComputePreSsoConnectionInfoResponse>()(
  SsoRequestTypes.GetPreSsoConnectionInfoRequest,
  SsoRequestTypes.GetPreSsoConnectionInfoSuccess,
  SsoRequestTypes.GetPreSsoConnectionInfoFailure,
);

type SsoSettingsState = {
  requested: boolean;
  loading: boolean;
  data: SsoSettings | null;
};

const initialState: SsoSettingsState = {
  requested: false,
  loading: false,
  data: null,
};

function ssoSettings(state: SsoSettingsState = initialState, action: SsoActions): SsoSettingsState {
  switch (action.type) {
    case SsoRequestTypes.GetSsoSettingsRequest:
      return {
        ...state,
        requested: true,
        loading: true,
      };
    case SsoRequestTypes.GetSsoSettingsSuccess:
    case SsoRequestTypes.ProvisionSsoSuccess:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case SsoRequestTypes.GetSsoSettingsFailure:
      return {
        ...state,
        loading: false,
      };
    case SsoRequestTypes.DeprovisionSsoSuccess:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}

type SsoReducerState = {
  preSsoConnectionInfo: ReturnType<typeof preSsoConnectionInfo>;
  ssoSettings: ReturnType<typeof ssoSettings>;
};

export const ssoReducer = combineReducers<SsoReducerState>({
  preSsoConnectionInfo,
  ssoSettings,
});
